export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1F2937] py-16 relative overflow-hidden">
      {/* Background Wordmark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none">
        <span className="text-[200px] font-bold text-white">CHARLESTON</span>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Logo and Tagline */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/235f330b-f882-4107-a5d6-be34726515e3.png" 
              alt="Charleston Junk Removers Logo" 
              className="h-10 w-auto"
            />
            <h3 className="text-2xl font-bold text-white">Charleston Junk Removers</h3>
          </div>
          <p className="text-[#9CA3AF] text-sm">Charleston's Trusted Junk Removal Service</p>
        </div>

        {/* Contact Information */}
        <div className="text-center mb-8 space-y-2">
          <a href="tel:+15134489448" className="flex items-center justify-center gap-2 text-white text-xl font-semibold hover:text-[#FF6B4A] transition-colors">
            <i className="ri-phone-fill"></i>
            (513) 448-9448
          </a>
          <a href="mailto:charlestonjunkremovers@gmail.com" className="block text-[#9CA3AF] hover:text-[#FF6B4A] transition-colors">
            charlestonjunkremovers@gmail.com
          </a>
          <p className="text-[#9CA3AF] text-sm">Charleston, SC and surrounding areas</p>
        </div>

        {/* Divider */}
        <div className="border-t border-[#374151] my-8"></div>

        {/* Bottom Section */}
        <div className="text-center space-y-4">
          <p className="text-[#9CA3AF] text-xs">
            © {currentYear} Charleston Junk Removers. All rights reserved.
          </p>
          <div className="flex items-center justify-center gap-4 text-[#9CA3AF] text-xs">
            <a href="#" className="hover:text-[#FF6B4A] transition-colors">Privacy Policy</a>
            <span>|</span>
            <a href="#" className="hover:text-[#FF6B4A] transition-colors">Terms of Service</a>
            <span>|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B4A] transition-colors">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
